// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"PV-z","inlineTitle":"QV-z","sponsoredAdsWrapper":"RV-z","marketplaceRecosWrapper":"SV-z"};